import {stageWithProfile} from './ProjectStageCache';
import {StageProfile, stageLabel} from './projectStageUtil';

type StageIntl = Parameters<typeof stageLabel>[1];

/**
 * The input fields that move a project to the first stage with the given profile: its `stageId` when the stage
 * cache holds one, otherwise the profile as `status`, which the backend still accepts.
 */
export const stageChangeInput = (profile: StageProfile): {stageId: string} | {status: StageProfile} => {
	const stage = stageWithProfile(profile);
	return stage ? {stageId: stage.id} : {status: profile};
};

/** The picker options relabelled with the cached stage for each option's profile; unchanged when none is cached. */
export const withCachedStageLabels = <T extends {value: string; label: string}>(options: T[], intl: StageIntl): T[] =>
	options.map(option => {
		const stage = stageWithProfile(option.value as StageProfile);
		return stage ? {...option, label: stageLabel(stage, intl) || option.label} : option;
	});
